import Loadable from '../../components/loadable';

const ArchivedWaiversList = Loadable({
  loader: () => import('../../pages/waivers/archived_waivers_list/archived_waiver_list'),
  type: 'block',
});

angular.module('gym').value('ArchivedWaiversList', ArchivedWaiversList);

const UnarchiveWaiverModal = Loadable({
  loader: () => import('../../pages/waivers/archived_waivers_list/unarchive_waiver_modal'),
  type: 'modal',
});

angular.module('gym').value('UnarchiveWaiverModal', UnarchiveWaiverModal);

const WaiverDetailsModal = Loadable({
  loader: () => import('../../pages/waivers/archived_waivers_list/waiver_details_modal'),
  type: 'modal',
});

angular.module('gym').value('WaiverDetailsModal', WaiverDetailsModal);
